import script from "./UpdateDataSioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateDataSioPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateDataSioPage.vue?vue&type=style&index=0&id=c8470206&scoped=true&lang=css"
import "./UpdateDataSioPage.vue?vue&type=style&index=1&id=c8470206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8470206"]])

export default __exports__